import React, { useContext, useEffect, useRef } from "react";
import { ServiceIcons } from "@monorepo/components";
import theme from "@monorepo/styles/theme";
import { ServiceCategoryIdEnum } from "@monorepo/types";
import { ListItem, Typography } from "@mui/material";

import { ServiceListAutocompleteContext } from "./ServiceListAutocomplete";

interface IServiceListItemProps {
  id: string;
  name: string;
  serviceId: ServiceCategoryIdEnum;
  onServiceSelect: (id: string) => void;
  index: number;
}

export const ServiceListAutocompleteItem = React.memo(
  ({ id, name, serviceId, onServiceSelect, index }: IServiceListItemProps) => {
    const {
      activeIndex,
      setActiveIndex,
      setActiveServiceId,
      setSearchValue,
      arrowsNavigationActive,
      setArrowsNavigationActive,
    } = useContext(ServiceListAutocompleteContext);

    const ref = useRef<HTMLLIElement | null>(null);

    useEffect(() => {
      if (activeIndex === index) {
        setActiveServiceId(id);
        if (arrowsNavigationActive) {
          setSearchValue(name);
          ref.current?.scrollIntoView({ block: "nearest" });
        }
      }
    }, [activeIndex, index, setActiveServiceId, id, setSearchValue, name, arrowsNavigationActive]);

    return (
      <ListItem
        sx={{
          display: "flex",
          alignItems: "center",
          columnGap: theme.spacing(2),
          cursor: "pointer",
          padding: "12px",
          borderRadius: "12px",
          backgroundColor: activeIndex === index ? theme.palette.card.dark : "inherit",
          color: activeIndex === index ? theme.palette.secondary.main : "inherit",
        }}
        role="presentation"
        tabIndex={-1}
        key={id}
        onClick={() => {
          onServiceSelect(id);
        }}
        onMouseEnter={() => {
          if (arrowsNavigationActive) {
            setArrowsNavigationActive(false);
          }
          setActiveIndex(index);
        }}
        ref={ref}
      >
        <ServiceIcons serviceId={serviceId} />
        <Typography component="span">{name}</Typography>
      </ListItem>
    );
  }
);
